import React, { ReactNode } from 'react';
import url from '@/utils/config';
import Link from 'next/link';

type Props = {
  href: string;
  children: ReactNode;
  ariaLabel?: string;
};

/**
 * 外部サイトを別タブで開く共通リンク部品。
 * @param props 外部URLと表示内容
 * @returns 外部リンク表示
 */
const ExternalLink = ({ href, children, ariaLabel }: Props) => {
  return (
    <Link
      href={href}
      className='m-link'
      target='_blank'
      rel='noreferrer'
      data-testid='notification_link'
      aria-label={ariaLabel}
    >
      {/* 別タブ遷移であることをアイコンと alt で補足する。 */}
      <img className='m-link__img' src={url('/images/icon_blank.svg')} alt='別タブで開きます' />
      {children}
    </Link>
  );
};

ExternalLink.defaultProps = {
  ariaLabel: undefined,
};

export default ExternalLink;
